import { useEffect } from "react";
// import useAuth from "../../hooks/useAuth";
import { useNavigate } from "react-router";
import SplashScreen from "../../Components/SplashScreen";
import firebase from "../../lib/firebase";
// import gtm from "../../lib/gtm";

export default function Loading(props) {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectUser = () => {
      const unSub = firebase.auth().onAuthStateChanged((user) => {
        user ? navigate("/dashboard") : navigate("/authentication/login");
      });

      setTimeout(() => {
        unSub();
      }, 1000);
    };

    redirectUser();
    // gtm.push({ event: "page_view" });
  }, [navigate]);

  return <SplashScreen />;
}
